import CardTravelOutlinedIcon from "@mui/icons-material/CardTravelOutlined";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const imageArray = [
  {
    imageUrl: <CardTravelOutlinedIcon />,
    color: "rgba(6, 190, 108, 0.05)",
    iconColor: "#0fd17b",
  },
  {
    imageUrl: <AccessTimeIcon />,
    color: "rgba(253, 127, 35, 0.05)",
    iconColor: "#1db5d8",
  },
  {
    imageUrl: <PersonAddAltIcon />,
    color: "rgba(68, 63, 177, 0.05)",
    iconColor: "#443fb1",
  },
];

export default imageArray;